import { axios, base } from '../http';

/** 清卡/退床配置 */
export const getEnrollmentUnbindOptions = (schoolId) =>
  axios.get(`${base}/api/StudentEnrollmentArchive/GetUnbindOptions`, { params: { schoolId } });

export const saveEnrollmentUnbindOptions = (data) =>
  axios.post(`${base}/api/StudentEnrollmentArchive/SaveUnbindOptions`, data);

/** 转退列表（传顶栏 schoolId 即可） */
export const getTransferLeavePage = (params) =>
  axios.get(`${base}/api/StudentEnrollmentArchive/GetTransferLeavePage`, { params });

/** 毕业届别树 */
export const getGraduateYearTree = (params) =>
  axios.get(`${base}/api/StudentEnrollmentArchive/GetGraduateYearTree`, {
    params: typeof params === 'string' ? { schId: params } : params
  });

/** 毕业档案列表 */
export const getGraduateArchivePage = (params) =>
  axios.get(`${base}/api/StudentEnrollmentArchive/GetGraduateArchivePage`, { params });

/** 在读异动：休学/转学/退学 */
export const changeEnrollmentStatus = (data) =>
  axios.post(`${base}/api/StudentEnrollmentArchive/ChangeStatus`, data);

/** 批量办理休学/转学/退学 */
export const batchChangeEnrollmentStatus = (data) =>
  axios.post(`${base}/api/StudentEnrollmentArchive/BatchChangeStatus`, data);

/** 复学 */
export const resumeEnrollment = (data) =>
  axios.post(`${base}/api/StudentEnrollmentArchive/Resume`, data);

/** 毕业回退 */
export const rollbackGraduate = (data) =>
  axios.post(`${base}/api/StudentEnrollmentArchive/RollbackGraduate`, data);

/** 升学导入：按整届汇总来源毕业班 */
export const getPromotionClassOptions = (params) =>
  axios.get(`${base}/api/StudentEnrollmentArchive/GetPromotionClassOptions`, { params });

/** 升学导入 */
export const promotionImport = (data) =>
  axios.post(`${base}/api/StudentEnrollmentArchive/PromotionImport`, data);

/** 修改原因 */
export const updateEnrollmentReason = (data) =>
  axios.post(`${base}/api/StudentEnrollmentArchive/UpdateReason`, data);

/** 检查毕业/转退归档学生天波残留 */
export const checkArchiveTbResidual = (data) =>
  axios.post(`${base}/api/StudentEnrollmentArchive/CheckArchiveTbResidual`, data);

/** 批量从天波清除归档/休学学生（不删本地档案） */
export const batchDeleteArchiveTbResidual = (data) =>
  axios.post(`${base}/api/StudentEnrollmentArchive/BatchDeleteArchiveTbResidual`, data);
